import React, { useEffect } from 'react'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { SiteNav, Footer, isHomeRoute } from './layout'

import { FirestoreProvider } from './firebase/firestore/FirestoreContext'
import { Routes } from './Routes'

// We need To add the toastify css because purgecss removes it otherwise? I think?  we definitely need it though.
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Carousel CSS
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader

// Filepond CSS
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css'
import 'filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css'

import { UIProvider } from './shared/context/UIContext'

const reactQueryClient = new QueryClient()

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

/** The home page hero runs to the top of the screen, so it skips the nav padding */
const Shell = () => {
  const { pathname } = useLocation()
  const isHome = isHomeRoute(pathname)

  return (
    <div className={`flex flex-col [overflow-x:clip] ${isHome ? '' : 'pt-16'}`}>
      <SiteNav />

      <Routes />

      <Footer />
    </div>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      {/* <CurrentUserProvider> */}
      <UIProvider>
        <QueryClientProvider client={reactQueryClient}>
          <FirestoreProvider>
            <ToastContainer />
            <ScrollToTop />
            <Shell />
          </FirestoreProvider>
        </QueryClientProvider>
      </UIProvider>
      {/* </CurrentUserProvider> */}
    </BrowserRouter>
  )
}

export default App
